import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import { supabase } from "../lib/supabase";

export function ResetPasswordPage() {
  const {
    user,
    loading,
    configured,
    passwordRecovery,
    clearPasswordRecovery,
  } = useAuth();

  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [completed, setCompleted] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setError(null);

    if (!configured) {
      setError("Falta configurar Supabase en las variables de entorno.");
      return;
    }

    if (!passwordRecovery || !user) {
      setError(
        "Esta sesión no corresponde a un enlace válido de recuperación.",
      );
      return;
    }

    if (password.length < 12) {
      setError("La nueva contraseña debe tener al menos 12 caracteres.");
      return;
    }

    if (password !== passwordConfirm) {
      setError("Las contraseñas no coinciden.");
      return;
    }

    setSubmitting(true);

    const { error: updateError } = await supabase.auth.updateUser({
      password,
    });

    setSubmitting(false);

    if (updateError) {
      setError(updateError.message);
      return;
    }

    clearPasswordRecovery();
    setPassword("");
    setPasswordConfirm("");
    setCompleted(true);
  }

  if (loading) {
    return (
      <main className="center-screen">
        <div className="loading-card">Validando enlace…</div>
      </main>
    );
  }

  if (!user || !passwordRecovery) {
    return (
      <main className="login-page">
        <section className="login-panel">
          <div className="login-heading">
            <span className="eyebrow">CORE SaaS · QA</span>
            <h1>Enlace no válido</h1>
            <p>
              El enlace de recuperación venció, ya fue utilizado o no pudo
              establecer una sesión segura.
            </p>
          </div>

          <Link className="primary-link-button" to="/login">
            Solicitar otro enlace
          </Link>
        </section>
      </main>
    );
  }

  if (completed) {
    return (
      <main className="login-page">
        <section className="login-panel">
          <div className="login-heading">
            <span className="eyebrow">CORE SaaS · QA</span>
            <h1>Contraseña actualizada</h1>
            <p>
              Tu nueva contraseña ya está activa. Puedes continuar con tu
              sesión.
            </p>
          </div>

          <Link className="primary-link-button" to="/">
            Entrar al panel
          </Link>
        </section>
      </main>
    );
  }

  return (
    <main className="login-page">
      <section className="login-panel">
        <div className="login-heading">
          <span className="eyebrow">CORE SaaS · QA</span>
          <h1>Nueva contraseña</h1>
          <p>
            Define una contraseña nueva para {user.email ?? "tu cuenta"}.
          </p>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <label>
            Nueva contraseña
            <input
              type="password"
              autoComplete="new-password"
              minLength={12}
              required
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </label>

          <label>
            Confirmar contraseña
            <input
              type="password"
              autoComplete="new-password"
              minLength={12}
              required
              value={passwordConfirm}
              onChange={(event) => setPasswordConfirm(event.target.value)}
            />
          </label>

          {error ? <div className="form-error">{error}</div> : null}

          <button
            className="primary-button"
            type="submit"
            disabled={submitting}
          >
            {submitting ? "Actualizando…" : "Guardar nueva contraseña"}
          </button>
        </form>
      </section>
    </main>
  );
}
